const NO_CAPTCHA_REQUIRED_STATUS = 'No captcha response required by the backend'

// https://docs.hcaptcha.com/#siteverify-error-codes-table
// https://docs.hcaptcha.com/configuration/#error-codes
const CAPTCHA_ERRORS = new Set([
  'bad-request',
  'challenge-error',
  'internal-error',
  'invalid-data',
  'invalid-input-response',
  'invalid-input-secret',
  'missing-input-response',
  'missing-input-secret',
  'network-error',
  'rate-limited',
  'timeout-or-duplicate',
])

const MAX_RETRY_COUNT = 3

export { CAPTCHA_ERRORS, MAX_RETRY_COUNT, NO_CAPTCHA_REQUIRED_STATUS }
